module.exports = __webpack_public_path__ + "svg_80x80/perl.70df75.svg";